import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { AppinfoService } from './appinfo.service';

@Injectable()
export class ResolverAppinfoService implements Resolve<any> {

	constructor(
		private appinfoService: AppinfoService
	) { }

	async resolve(): Promise<void> {
		await this.appinfoService.getAppinfo();
		return;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/resolver-appinfo.service.ts